import axiosInstance from "../api/axiosInstance";

export interface Template {
  id: number;
  slug: string;
  name: string;
  description: string;
  tags: string[];
  content: string;
}

export const getTemplates = async (): Promise<Template[]> => {
  const response = await axiosInstance.get("/templates/templates/");
  return response.data;
};

export const getTemplateBySlug = async (slug: string): Promise<Template> => {
  const response = await axiosInstance.get(`/templates/templates/${slug}/`);
  return response.data;
};

export const addCustomTemplates = async (templates: {
  template_ids: number[];
}): Promise<void> => {
  await axiosInstance.post("/templates/custom/", templates);
};
